import { render, staticRenderFns } from "./ChannelListVue.vue?vue&type=template&id=7a8e2d7c&"
import script from "./ChannelListVue.vue?vue&type=script&lang=js&"
export * from "./ChannelListVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports